module.exports = __webpack_public_path__ + "img/master.532b77b2.png";